import GitHubFinder from "./components/GitHubFinder";

function App() {
  return (
    <div className="App">
      <GitHubFinder />
    </div>
  );
}

export default App;
